var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"squares"},_vm._l((4),function(i){return _c('div',{key:i,staticClass:"square"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }